import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function AboutPaula() {
  return <section className="bg-cream-light py-14 md:py-20" data-id="element-22">
      <div className="max-w-5xl mx-auto px-6" data-id="element-23">
        <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center" data-id="element-24">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2 relative" data-id="element-25">
            <div className="absolute -inset-4 border border-gold-main/30 rounded-sm transform rotate-3" data-id="element-26"></div>
            <img src="https://cdn.magicpatterns.com/uploads/29NxcQqDS3LEvn4F44HhTt/IMG_9091_1.webp" alt="Paula Giraldo oficiando una ceremonia" className="relative z-10 w-full h-auto object-cover rounded-sm shadow-lg aspect-[4/5]" loading="lazy" data-id="element-27" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full md:w-1/2 space-y-5" data-id="element-28">
            <h2 className="text-3xl md:text-4xl font-playfair font-bold text-brown-dark" data-id="element-29">
              Hola, soy Paula Giraldo,
            </h2>

            <div className="space-y-4 font-lora text-lg text-brown-light leading-relaxed" data-id="element-30">
              <p data-id="element-31">
                Y seré la responsable de guiarte en todo este eBook, he cuidado
                cada detalle para que tengas una experiencia teórica y práctica
                como ninguna otra, para poder hacer tus espacios de manera
                personal pero también poder guiarlos de manera profesional y
                consciente.
              </p>
              <p data-id="element-32">
                Me puedes encontrar en redes como{' '}
                <span className="font-semibold text-gold-dark" data-id="element-33">
                  @ceremoniasimbólicas.paula
                </span>{' '}
                por si quieres saber un poco más de mí.
              </p>
              <p className="pt-2 italic text-brown-dark border-l-2 border-gold-main pl-4" data-id="element-34">
                Durante años he acompañado a cientos de personas en momentos
                importantes de sus vidas a través de espacios sagrados. Mi
                trabajo se basa en integrar espiritualidad consciente, trabajo
                sistémico, rituales simbólicos y acompañamiento emocional.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}